import { useEffect } from "react"
import { useState } from "react"

const Pagination = ({ className, itemsPerPage, totalItems, onPageChange }) => {
    const maxVisiblePages = 3; // Maximum number of visible page numbers
    const [pagination, setPagination] = useState([1])
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)

    useEffect(() => {
        let temp = Math.ceil(totalItems / itemsPerPage)
        setTotalPages(temp)
    }, [totalItems, itemsPerPage])

    useEffect(() => {
        let temp = []
        // Calculate the start and end page numbers
        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        // Adjust startPage if endPage is less than maxVisiblePages
        if (endPage - startPage < maxVisiblePages - 1) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        // Add first page
        if (startPage > 1) {
            temp.push(1);
            if (startPage > 2) temp.push('...'); // Add ellipsis
        }

        // Add page numbers
        for (let i = startPage; i <= endPage; i++) {
            temp.push(i);
        }

        // Add last page
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) temp.push('...'); // Add ellipsis
            temp.push(totalPages);
        }

        setPagination(temp)
        onPageChange(currentPage)
    }, [currentPage, totalPages])

    const goToPrev = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1)
    }

    const goToNext = () => {
        if (totalPages > currentPage) setCurrentPage(currentPage + 1)
    }

    return (
        totalPages > 1 &&
        <div className={`flex justify-center text-white text-sm ${className}`}>
            <button
                className={`mr-8 flex justify-center items-center rounded-[50%] w-[44px] h-[44px] bg-white cursor-pointer ${currentPage === 1 ? 'opacity-50' : ''}`}
                onClick={goToPrev}
                disabled={currentPage === 1}
            >
                <img src="/assets/icons/icon-arrow-long-left.svg" alt="prev" />
            </button>

            {
                pagination.map((page, index) =>
                    <button
                        key={`page-${index}`}
                        className={`${page === totalPages ? '' : 'mr-5'} ${page === currentPage ? 'text-primary' : ''}`}
                        disabled={page === '...'}
                        onClick={() => setCurrentPage(page)}
                    >
                        {page}
                    </button>
                )
            }

            <button
                className={`ml-8  flex justify-center items-center rounded-[50%] w-[44px] h-[44px] bg-white cursor-pointer ${totalPages === currentPage ? 'opacity-50' : ''}`}
                onClick={goToNext}
            >
                <img src="/assets/icons/icon-arrow-long-right.svg" alt="prev" />
            </button>
        </div >
    )
}

export default Pagination